import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { OModalMedia as OModalMediaComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OModalMediaConfig = {
  emptyLabel: 'OModalMedia',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-modal-media`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OModalMedia = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div
      data-testid="o-modal-media-comp"
      data-component-name="o-modal-media"
      id={componentId}
      className={clsx(styleclass)}
    >
      <EditableComponent config={OModalMediaConfig} {...props}>
        <OModalMediaComp {...props} />
      </EditableComponent>
    </div>
  );
};
